import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export const PATH_CASH_RECEIPT = 'cashReceipt';
export const PATH_CONTACT = 'contact';
export const PATH_CONTACTS = 'contacts';
export const PATH_CONTACT_NEW = 'contactNew';
export const PATH_CONTACT_US = 'contactUs';
export const PATH_COOKIES = 'cookiesPolicy';
export const PATH_DASHBOARD = 'dashboard';
export const PATH_DELIVERY_NOTE = 'deliveryNote';
export const PATH_DIRECT_EXTEND = 'directExtend';
export const PATH_EXPENSE = 'expense';
export const PATH_EXPENSES = 'expenses';
export const PATH_EXPENSE_CLONE = 'expenseClone';
export const PATH_EXPENSE_NEW = 'expenseNew';
export const PATH_FAQ = 'faq';
export const PATH_GIFT = 'gift';
export const PATH_HELP = 'help';
export const PATH_INVOICE = 'invoice';
export const PATH_INVOICES_OVERVIEW = 'invoicesOverview';
export const PATH_INVOICE_CLONE = 'invoiceClone';
export const PATH_INVOICE_CREDIT_NOTE = 'invoiceCreditNote';
export const PATH_INVOICE_EDIT = 'invoiceEdit';
export const PATH_INVOICE_KIND = 'invoiceKind';
export const PATH_INVOICE_SHOW = 'invoiceShow';
export const PATH_INVOICE_TEMPLATES = 'invoiceTemplates';
export const PATH_INVOICE_TEMPLATES_GOOGLE = 'invoiceTemplatesGoogle';
export const PATH_INVOICE_TEMPLATES_PDF = 'invoiceTemplatesPdf';
export const PATH_INVOICE_TEMPLATE_SHOW = 'invoiceTemplateShow';
export const PATH_INVOICE_TYPES = 'invoiceTypes';
export const PATH_LANDING = 'landing';
export const PATH_MIGRATE_LINES = 'migrateLines';
export const PATH_NEWBIES = 'newbies';
export const PATH_NEW_REGISTRATION = 'newRegistration';
export const PATH_NGO = 'ngo';
export const PATH_ORDER = 'order';
export const PATH_PRICELIST = 'pricelist';
export const PATH_PRIVACY_TERMS = 'privacyTerms';
export const PATH_REPORTS = 'reports';
export const PATH_ROOT = 'root';
export const PATH_SAVED_LINES = 'savedLines';
export const PATH_SEND_FORGOTTEN_CODE = 'sendForgottenCode';
export const PATH_SIGNIN_LOGIN = 'signinLogin';
export const PATH_TERMS_CONDITIONS = 'termsAndConditions';
export const PATH_WORD_EXCEL = 'wordExcel';

const componentMap = {
  path_invoice: {
    component: 'pages/Invoice',
    props: { invoiceType: 'new' },
  },
  path_invoice_template_show: {
    component: 'pages/Profession',
  },
  path_invoice_templates: {
    component: 'pages/Professions',
  },
  path_invoice_kind: {
    component: 'pages/Invoice',
    props: { invoiceType: 'new' },
  },
  path_invoice_show: { component: 'components/InvoiceDetail/InvoiceDetail' },
  path_invoice_edit: {
    component: 'pages/Invoice',
    props: { invoiceType: 'edit' },
  },
  path_invoice_clone: {
    component: 'pages/Invoice',
    props: { invoiceType: 'clone' },
  },
  path_invoice_credit_note: {
    component: 'pages/Invoice',
    props: { invoiceType: 'credit_note' },
  },
  path_invoices_overview: { component: 'pages/Invoices' },
  path_delivery_note: { component: 'pages/DeliveryNote' },
  path_cash_receipt: { component: 'pages/CashReceipt' },
  path_dashboard: { component: 'pages/Dashboard' },
  path_contacts: { component: 'components/Contacts/ContactsList' },
  path_contact: { component: 'components/Contacts/ContactShow' },
  path_contact_new: { component: 'components/Contacts/ContactNew' },
  path_reports: { component: 'pages/Reports' },
  path_signin_login: { component: 'pages/SignInSignUp' },
  path_pricelist: { component: 'pages/Pricelist' },
  path_order: { component: 'pages/Order' },
  path_expense_new: { component: 'components/Expenses/ExpenseNew' },
  path_expense: { component: 'components/Expenses/ExpenseShow' },
  path_expense_clone: { component: 'components/Expenses/ExpenseClone' },
  path_expenses: { component: 'pages/Expenses' },
  path_send_forgotten_code: { component: 'pages/ResetPassword' },
  path_ngo: { component: 'pages/NGO' },
  path_newbies: { component: 'pages/Newbies' },
  path_word_excel: { component: 'pages/WordExcel' },
  path_invoice_templates_google: { component: 'pages/InvoiceTemplatesGoogle' },
  path_invoice_templates_pdf: { component: 'pages/InvoiceTemplatesPDF' },
  path_landing: { component: 'pages/Landing' },
  path_gift: { component: 'pages/Landing' },
};

const loadComponent = (name) => {
  const componentName = componentMap[name]?.component;
  return () => import(/* webpackChunkName: "pages" */`~/${componentName}.vue`);
};

const routeArray = window.vueRoutes || [];

/* eslint-disable no-eval */
const routeMap = routeArray.map((entry) => {
  const componentName = componentMap[entry.name]?.component;
  const route = {
    path: entry.path,
    name: eval(entry.name.toUpperCase()),
    props: componentMap[entry.name]?.props,
  };

  if (componentName) {
    route.component = loadComponent(entry.name);
  }

  return route;
});
/* eslint-enable no-eval */

const router = new VueRouter({
  routes: routeMap,
  mode: 'history',
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

const staticRoutes = [
  PATH_CASH_RECEIPT,
  PATH_CONTACT_US,
  PATH_COOKIES,
  PATH_DELIVERY_NOTE,
  PATH_FAQ,
  PATH_HELP,
  PATH_PRIVACY_TERMS,
  PATH_TERMS_CONDITIONS,
  PATH_NGO,
  PATH_NEWBIES,
  PATH_WORD_EXCEL,
  PATH_INVOICE_TEMPLATES_GOOGLE,
  PATH_INVOICE_TYPES,
];

router.beforeEach((to, from, next) => {
  if (staticRoutes.includes(to.name)) {
    if (window.location.pathname !== to.path) {
      next(false);
      window.location.href = to.path;
    } else {
      next();
    }
    return;
  }

  if (!document.body.classList.contains('vue-page') || to.name === 'directExtend') {
    if (window.location.pathname === to.path) {
      next();
    } else {
      next(false);
      window.location.href = to.path;
    }
  } else {
    next();
  }
});

export default router;
